import React, {Component} from 'react';
import {connect} from 'react-redux';
import {
    autoFillTeam,
} from './../../actions/FormationActions';
import config from './../../config';
import common from './../../common';

class AutoCompleteTeam extends Component {
    render() {
        const {budget, playerCount, trans} = this.props;
        const isAutoCompleteDisabled = (playerCount === config.MAX_PLAYERS_PER_TEAM) || (budget < 0);
        const isMobile = config.isMobile;
        const autoCompleteClass = common.makeClasses({
            'si-new-comp' : true,
            'si-auto-fill': true,
            'si-inactive' : isAutoCompleteDisabled
        });
        let autoCompleteHandler = {};
        if (!isAutoCompleteDisabled) {
            autoCompleteHandler = {onClick: () => this.props.autoFillTeam()};
        }
        return <div className={autoCompleteClass} {...autoCompleteHandler}>
            <i className="icon-ucl-Auto-Complete"/>
            {!isMobile ? <span>{trans.auto} <br/>{trans.complete}</span> : null}
        </div>
    }
}

const mapStateToProps = (state) => {
    return {
        trans      : state.appData.trans,
        budget     : state.formationData.teamData.budget,
        playerCount: state.formationData.teamData.playerCount,
        commonError: state.formationData.commonError,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        autoFillTeam: () => dispatch(autoFillTeam()),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(AutoCompleteTeam);


// WEBPACK FOOTER //
// ./src/components/onboarding/AutoCompleteTeam.js